export default class extends HTMLElement {
  connectedCallback () {
    this.id = `autoresize-textarea-${Math.random().toString(32).split('.')[1]}`

    this.resize()

    this.textarea.addEventListener('input', () => this.resize())

    this.observeVisibility()
  }

  resize () {
    this.minHeight ||= this.textarea.clientHeight

    const borderHeight = this.textarea.offsetHeight - this.textarea.clientHeight

    this.textarea.style.height = 'auto'
    this.textarea.style.height = `${Math.max(this.minHeight, this.textarea.scrollHeight + borderHeight)}px`
  }

  observeVisibility () {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.resize()
            this.observer.unobserve(this.textarea)
          }
        })
      },
      {
        threshold: 0.1
      }
    )

    this.observer.observe(this.textarea)
  }

  disconnectedCallback () {
    this.observer.unobserve(this.textarea)
  }

  get textarea () {
    return this.querySelector('textarea')
  }
}
